import React, { FC } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface StyledTagProps {
  label: string;
  onDelete?: () => void;
  color?: string;
  backgroundColor?: string;
  disabled?: boolean;
}

export const StyledTag: FC<StyledTagProps> = ({
  label,
  onDelete,
  color = '#1976D2',
  backgroundColor = '#E3F2FD',
  disabled = false
}) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor,
        borderRadius: '16px',
        padding: '4px 8px',
        margin: '4px',
        cursor: 'default'
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color,
          fontSize: '0.875rem',
          fontWeight: 500,
          marginRight: onDelete && !disabled ? '4px' : 0
        }}
      >
        {label}
      </Typography>
      {onDelete && !disabled && (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          sx={{
            padding: '2px',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CloseIcon sx={{ fontSize: '1rem', color }} />
        </IconButton>
      )}
    </Box>
  );
};
